module.exports = __webpack_public_path__ + "img/structure-management.ee336cd6.png";